<template>
  <div>
    <el-drawer :visible.sync="drawer" :with-header="false" size="600px" @close="close">
      <div class="item-box-content">
        <div class="title-font-style">
          <span>出库信息</span>
        </div>
        <el-form :model="queryParams" ref="formRef" :rules="ruleForm" label-width="100px">
          <el-row :gutter="20" style="padding-top:20px;">
            <el-col :span="20">
              <el-form-item label="选择仓库：" prop="storageName">
                <el-select
                  v-model.trim="queryParams.storageName"
                  @change="storageChange"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="(item,index) in storge"
                    :key="index"
                    :label="item.storageName"
                    :value="item.storageName"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="20">
              <el-form-item label="仓库地址：">{{queryParams.storageAddress||"--"}}</el-form-item>
            </el-col>
            <el-col :span="20">
              <el-form-item label="联系电话：">{{queryParams.storagePhone||"--"}}</el-form-item>
            </el-col>
          </el-row>
          <div class="title-font-style">
            <span>物流信息</span>
          </div>

          <el-row :gutter="20" style="padding-top:20px;">
            <el-col :span="20">
              <el-form-item label="配送方式：" prop="deliverType">
                <el-select
                  v-model.trim="queryParams.deliverType"
                  @change="deliverTypeChange"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="(item,index) in distributionList"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col
              :span="20"
              v-if="queryParams.deliverType ==='物流配送'||queryParams.deliverType ==='快递配送'"
            >
              <el-form-item label="物流费用：">
                <el-select v-model.trim="queryParams.logisticCost" placeholder="请选择">
                  <el-option
                    v-for="(item,index) in logisticCostList"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="20">
              <el-form-item label="备注：" prop="mark">
                <el-input v-model.trim="queryParams.mark" type="textarea" :min="3"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <div
            class="title-text"
            v-if="queryParams.deliverType ==='物流配送'||queryParams.deliverType ==='快递配送'"
          >
            <span class="text-title">{{"如需仓储发货时到付请选择物流费用由收件人承担"}}</span>
          </div>
          <el-row
            :gutter="20"
            style="padding:20px 30px 0 0px"
            v-if="queryParams.deliverType !=='供应商自提'"
          >
            <el-col :span="20">
              <el-form-item label="发货人：" prop="consigner">
                <el-input v-model.trim="queryParams.consigner"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="20">
              <el-form-item label="联系电话：" prop="consignerPhone">
                <el-input @input.native="onInput" v-model.trim="queryParams.consignerPhone"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="14">
              <el-form-item label="收货人：" :rules="filter_rules({required:true})">
                <el-consignee
                  ref="consigneeRefs"
                  :InfoList="InfoList"
                  @changeName="changeName"
                  :params="consigneeParams"
                ></el-consignee>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label-width="0">
                <el-button @click="onEditConsignee">编辑</el-button>
                <el-button @click="onAddConsignee">添加</el-button>
              </el-form-item>
            </el-col>
            <el-col :span="20">
              <el-form-item label="收货地址：">{{queryParams.consigneeAddress}}</el-form-item>
            </el-col>
            <el-col :span="20">
              <el-form-item label="联系电话：">
                <el-input @input.native="onInput" :disabled="true" v-model.trim="queryParams.consigneePhone"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div class="title-font-style">
          <span>出库产品</span>
        </div>
        <el-table
          border
          ref="tableRef"
          :data="dataList"
          max-height="378"
          tooltip-effect="dark"
          style="margin-top:20px;"
          :header-cell-style="tableHeader"
        >
          <el-table-column
            show-overflow-tooltip
            prop="purchaseContractRetreatContent.brandName"
            label="品牌"
          ></el-table-column>
          <el-table-column show-overflow-tooltip prop="seriesName" label="系列"></el-table-column>
          <el-table-column show-overflow-tooltip prop="proName" label="产品名称"></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="purchaseContractRetreatContent.proModel"
            label="型号"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="purchaseContractRetreatContent.proOrdernum"
            label="订货号"
          ></el-table-column>

          <el-table-column prop="actualCount" label="数量" width="140px">
            <template slot-scope="scope">
              <el-input-number
                v-model.trim="scope.row.actualCount"
                controls-position="right"
                :max="scope.row.actualCountMax"
                :min="0"
              ></el-input-number>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin-top:30px;text-align:center;">
          <el-button @click="onSubmit" type="primary">提交信息</el-button>
          <el-button @click="close" style="margin-left:20px;">取消</el-button>
        </div>
      </div>
    </el-drawer>
    <!-------------- 添加 编辑收货人 -------------->
    <edit-consignee-dialog @getCustomer="getCustomer" :id="id" ref="editConsigneeDialogRefs"></edit-consignee-dialog>
    <!-------------- 申请退款二次确认 -------------->
    <open-or-close
      ref="OpenOrCloseRefs"
      @onUpdataState="onUpdataState"
      :title="title"
      :content="content"
    ></open-or-close>
  </div>
</template>
<script>
import editConsigneeDialog from './editConsigneeDialog'
import Consignee from './consignee'
import openOrClose from '@/components/OpenOrClose/index'
import { deepClone } from '@/util'

import {
  queryRetreatProduct,
  queryRetreatLogisticStorage,
  querySupplierReceiveGoods,
  addRetreatLogistic
} from '@/api/purchase/purchasePlanList'
export default {
  components: {
    'el-consignee': Consignee,
    'edit-consignee-dialog': editConsigneeDialog,
    'open-or-close': openOrClose
  },
  watch: {
    dataList: {
      handler(val) {
        this.dataList.forEach(ele => {
          if (isNaN(ele.actualCount)) {
            ele.actualCount = 0
          }
        })
      },
      deep: true
    }
  },
  data() {
    const checkName = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('发货人不能为空'))
      } else {
        callback()
      }
    }
    const storage = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请选择仓库'))
      } else {
        callback()
      }
    }
    const checkPhone = (rule, value, callback) => {
      const myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
      if (!myreg.test(value)) {
        callback(new Error('请输入正确的手机号码'))
      } else {
        callback()
      }
    }
    const markRules = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('备注不能为空'))
      } else {
        callback()
      }
    }
    return {
      ruleForm: {
        storageName: [{ validator: storage, trigger: 'input', required: true }],
        mark: [{ validator: markRules, trigger: 'change', required: true }],
        deliverType: [{ required: true }],
        consigner: [{ validator: checkName, trigger: 'change', required: true }],
        consignerPhone: [
          {
            validator: checkPhone,
            trigger: 'change',
            required: true
          }
        ]
      },
      InfoList: [], // 发货人列表
      id: '',
      title: '',
      content: '',
      drawer: false,
      showCode: false,
      storge: [],
      queryParams: {
        deliverType: '物流配送',
        logisticCost: '合同结算'
      },
      dataList: [],
      distributionList: [
        {
          label: '物流配送',
          value: '物流配送'
        },
        {
          label: '供应商自提',
          value: '供应商自提'
        },
        {
          label: '快递配送',
          value: '快递配送'
        },
        {
          label: '仓库配送',
          value: '仓库配送'
        }
      ],
      logisticCostList: [
        {
          label: '合同结算',
          value: '合同结算'
        },
        {
          label: '收货人承担',
          value: '供应商自提'
        },
        {
          label: '提成结算',
          value: '快递配送'
        }
      ],
      consigneeParams: {}, // 收货人
      suId: ''
    }
  },
  methods: {
    onInput(e) {
      // 过滤非数字和符号
      const regName = /^[\d-]+$/
      if (!regName.test(e.target.value)) {
        e.target.value = ''
      } else {
        return true
      }
    },
    onUpdataState() {
      this.queryParams.purchaseContractRetreatProductVoList = this.dataList
      this.queryParams.pcrId = this.$route.query.pcrId
      addRetreatLogistic(this.queryParams)
        .then(res => {
          if (res.data.code === 200) {
            this.$emit('onFresh')
            this.$message.success('新建出库单成功！')
            this.close()
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    onSubmit() {
      this.$refs.formRef.validate(valid => {
        if (valid && this.queryParams.consignee) {
          let count = 0
          const reg = /^\+?[1-9][0-9]*$/
          this.dataList.forEach(ele => {
            count += ele.actualCount
          })
          console.log('count', count, reg.test(count))
          if (!reg.test(count)) {
            this.$message.error('出库产品必须是大于零的整数！')
          } else {
            this.title = '新建出库单'
            this.content = '确认新建出库单吗？'
            this.$refs.OpenOrCloseRefs.onInitial()
          }
        } else {
          this.$message.error('信息未填写完整')
        }
      })
    },
    deliverTypeChange() {
      this.queryParams.logisticCost = '合同结算'

      querySupplierReceiveGoods(this.suId)
        .then(res => {
          if (res.data.code === 200) {
            this.InfoList = res.data.obj
            if (this.InfoList !== null || this.InfoList.length > 0) {
              this.consigneeParams = this.InfoList[0]
              this.changeName(this.consigneeParams)
            }
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    getCustomer(item) {
      querySupplierReceiveGoods(this.suId)
        .then(res => {
          if (res.data.code === 200) {
            this.InfoList = res.data.obj
            this.consigneeParams = item
            this.changeName(item)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    changeName(item) {
      if (item.recProcode || item.recProvince) {
        const recParams = this.$analysisAddress(item.recProcode, item.recProvince)
        item.provinceReceiving = recParams.province
        item.cityReceiving = recParams.city
        item.districtReceiving = recParams.district
      }
      this.consigneeParams = item
      this.queryParams.consignee = item.recContacts
      this.queryParams.consigneeAddress = item.recAddress
      this.queryParams.consigneePhone = item.recPhone
      this.queryParams = deepClone(this.queryParams)
    },
    storageChange() {
      const params = this.storge.filter(ele => {
        return ele.storageName === this.queryParams.storageName
      })
      this.queryParams.storageAddress = params[0].storageAddress
      this.queryParams.storagePhone = params[0].storagePhone
      this.queryParams.sbId = params[0].id
      this.dataListChange()
    },
    // 报缺侧边栏初始化
    onInitialize(row) {
      this.suId = row
      this.drawer = true
      this.queryParams = {
        deliverType: '物流配送',
        logisticCost: '合同结算'
      }
      querySupplierReceiveGoods(row)
        .then(res => {
          if (res.data.code === 200) {
            this.InfoList = res.data.obj
            if (this.InfoList !== null || this.InfoList.length > 0) {
              this.consigneeParams = this.InfoList[0]
              this.changeName(this.consigneeParams)
            }
          }
        })
        .catch(err => {
          console.log(err)
        })
      queryRetreatLogisticStorage(this.$route.query.pcrId)
        .then(res => {
          if (res.data.code === 200) {
            this.storge = res.data.obj
            this.queryParams.storageName = this.storge[0].storageName
            this.queryParams.storageAddress = this.storge[0].storageAddress
            this.queryParams.storagePhone = this.storge[0].storagePhone
            this.queryParams.sbId = this.storge[0].id
            this.dataListChange()
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    dataListChange() {
      queryRetreatProduct(this.$route.query.pcrId, this.queryParams.sbId)
        .then(res => {
          if (res.data.code === 200) {
            this.dataList = res.data.obj
            this.dataList.forEach(ele => {
              ele.actualCountMax = ele.actualCount
            })
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 设置头部背景色
    tableHeader({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },

    // 关闭事件
    close() {
      this.drawer = false
      this.$refs.formRef.resetFields() // 去掉校验
    },
    // ---------------------------      收货人信息            -------------------------
    onAddConsignee() {
      // 添加收货人
      this.$refs.editConsigneeDialogRefs.onInitial('添加收货人', this.suId)
    },
    onEditConsignee() {
      // 编辑收货人
      if (this.consigneeParams.id) {
        this.$refs.editConsigneeDialogRefs.onInitial('修改收货人', this.consigneeParams)
      } else {
        this.$message.error('请选择需要编辑的收货人!')
      }
    }
  }
}
</script>
<style  lang="scss" scoped>
.title-text {
  margin: 0px 20px 14px;
  .text-title {
    // margin-left: 20px;
    font-size: 12px;
    font-weight: 400;
    color: #d35e5e;
    line-height: 12px;
  }
}
</style>
